module.exports = __webpack_public_path__ + "img/hud-03.1409fcd0.png";